import {
  Box,
  Card,
  CrudMode,
  DataDisplay,
  DateTimePicker,
  Grid,
  ValidationErrors,
  formatDate,
  pn,
  useElementBreakpoints,
} from "@compass/core";
import { DatePicker } from "components";
import { Developer, DeveloperViewResource } from "generated/openApi";
import { useDateTime } from "hooks";
import produce from "immer";
import moment from "moment";
import "moment-timezone";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const DatesSection = (props: {
  crudMode: CrudMode;
  developer: Developer;
  setDeveloper: (value: Developer) => void;
  viewResource: DeveloperViewResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, fullFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];
  const tenantTimezone = useSelector((state: RootState) => state.app.tenantTimezone);
  const formatDateTime = useDateTime();

  return (
    <Card header="Dates">
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={fullFieldBreakpoints}>
          <DataDisplay label="Client's Timezone">{tenantTimezone}</DataDisplay>
        </Grid>

        <Grid item xs={fullFieldBreakpoints}>
          <DataDisplay label="Browser's Timezone">
            <Box>{moment.tz.guess()}</Box>
            <Box>{moment.tz(moment.tz.guess()).zoneAbbr()}</Box>
            <Box>{moment.tz(moment.tz.guess()).format("Z z")}</Box>
          </DataDisplay>
        </Grid>

        <Grid item xs={fullFieldBreakpoints}>
          {props.crudMode === "view" && (
            <DataDisplay
              label={`${properties.find((x) => x.propertyName === pn<Developer>("date1"))?.displayName} (Date Only)`}
            >
              {formatDate(props.developer.date1)}
            </DataDisplay>
          )}
          {props.crudMode === "edit" && (
            <DatePicker
              label={`${properties.find((x) => x.propertyName === pn<Developer>("date1"))?.displayName} (Date Only)`}
              required={properties.find((x) => x.propertyName === pn<Developer>("date1"))?.required}
              errors={props.validationErrors[pn<Developer>("date1")]}
              value={props.developer.date1}
              onChange={(value) =>
                props.setDeveloper(
                  produce(props.developer, (draft) => {
                    draft.date1 = value;
                  })
                )
              }
            />
          )}
        </Grid>

        <Grid item xs={fullFieldBreakpoints}>
          <DataDisplay label="Date2">Never use DateTime type for frontend</DataDisplay>
        </Grid>

        <Grid item xs={fullFieldBreakpoints}>
          {props.crudMode === "view" && (
            <DataDisplay
              label={`${
                properties.find((x) => x.propertyName === pn<Developer>("date3"))?.displayName
              } (DatetimeOffset with timezone)`}
            >
              {formatDateTime(props.developer.date3)}
            </DataDisplay>
          )}
          {props.crudMode === "edit" && (
            <DateTimePicker
              label={`${
                properties.find((x) => x.propertyName === pn<Developer>("date3"))?.displayName
              } (DatetimeOffset with timezone)`}
              required={properties.find((x) => x.propertyName === pn<Developer>("date3"))?.required}
              errors={props.validationErrors[pn<Developer>("date3")]}
              value={props.developer.date3}
              onChange={(value) =>
                props.setDeveloper(
                  produce(props.developer, (draft) => {
                    draft.date3 = value;
                  })
                )
              }
            />
          )}
        </Grid>
      </Grid>
    </Card>
  );
};
